import React, { Component } from "react";
import "../../styles/components/Sliders/NextSlidersSmall.css";
class NextSlidersSmall extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="photo-small-section">
        <img
          src="http://ata.gov.al/wp-content/uploads/2018/10/ligjet.jpg"
          className="top-photo"
          alt=""
        />
        <a href>
          <div className="title-under">TItle</div>
        </a>
      </div>
    );
  }
}
export default NextSlidersSmall;
